import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDollarIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={16}
    fill="none"
    viewBox="0 0 12 16"
    {...props}
  >
    <path
      fill="#000"
      d="M6.54 3.409H5.28V0H6.54zM6.729 16H5.11v-3.409h1.618zm.809-1.948H3.654C1.912 14.052.5 12.838.5 11.34v-.696h1.618v.696c0 .73.688 1.503 1.536 1.503h3.883c1.25 0 2.265-1.053 2.265-2.129S8.788 8.765 7.537 8.765H4.463C2.32 8.765.828 7.34.828 5.495S2.319 2.3 4.463 2.3h3.883c1.742 0 3.154 1.002 3.154 2.5v.696H9.882V4.8c0-.73-.688-1.322-1.536-1.322H4.463c-1.25 0-2.264.872-2.264 1.948s1.013 2.13 2.264 2.13h3.074c2.144 0 3.638 1.313 3.638 3.157s-1.494 3.34-3.638 3.34"
    />
  </svg>
);
export default SvgDollarIcon;
